import CoursePrivateCoachingModuleForm from '@/views/App/Course/PrivateCoachingModule/Form.vue';
import CoursePrivateCoachingModuleList from '@/views/App/Course/PrivateCoachingModule/List.vue';
import RandomGoalList from '@/views/App/Course/PrivateCoachingModule/RandomModule/List.vue';

const routesCoursePrivateCoachingModule = [
    {
        path: 'list',
        name: 'coursePrivateCoachingModuleList',
        component: CoursePrivateCoachingModuleList
    },
    {
        path: 'form/:id?',
        name: 'coursePrivateCoachingModuleForm',
        component: CoursePrivateCoachingModuleForm
    },
    {
        path: 'random-goal-list',
        name: 'coursePrivateCoachingRandomGoalList',
        component: RandomGoalList
    },
];

export default routesCoursePrivateCoachingModule;